<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('student_slots_bulk_search')" :isNewButton="checkPermission('studentslot_bulksearch')" :isColumns="true"
					@new-button-click="createFormShow()" @filter-div-status="datatable.filterStatus = $event">
					<template v-slot:columns>
						<div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
							<b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
								:unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
								{{ column.label }}
							</b-form-checkbox>
						</div>
					</template>
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('student_slots_bulk_search')" :isNewButton="checkPermission('studentslot_bulksearch')" :isColumns="true"
					@new-button-click="createFormShow()" @filter-div-status="datatable.filterStatus = $event">
					<template v-slot:columns>
						<div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
							<b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
								:unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
								{{ column.label }}
							</b-form-checkbox>
						</div>
					</template>
				</HeaderMobile>
			</template>
			<datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
				<b-row>
					<!-- SLOT ID -->
					<b-col sm="6" md="3">
                        <b-form-group :label="$t('slot_id')">
                          <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.id"></b-form-input>
                        </b-form-group>
					</b-col>

					<!-- COURSE CODE -->
					<b-col sm="6" md="3">
						<b-form-group :label="$t('course_code')">
							<b-form-input type="text" v-model="datatable.queryParams.filter.key"></b-form-input>
						</b-form-group>
					</b-col>

					<!--  FACULTY CODE -->
					<b-col sm="6" md="3">
						<b-form-group :label="$t('faculty')">
							<faculty-selectbox v-model="datatable.queryParams.filter.faculty_code"></faculty-selectbox>
						</b-form-group>
					</b-col>

					<!-- DEPARTMENT CODE -->
					<b-col sm="6" md="3">
						<b-form-group :label="$t('department')">
							<department-selectbox :faculty_code="datatable.queryParams.filter.faculty_code"
								v-model="datatable.queryParams.filter.department_code"></department-selectbox>
						</b-form-group>
					</b-col>

					<!-- PROGRAM CODE -->
					<b-col sm="6" md="3">
						<b-form-group :label="$t('program')">
							<program-selectbox :faculty_code="datatable.queryParams.filter.faculty_code"
								:department_code="datatable.queryParams.filter.department_code"
								v-model="datatable.queryParams.filter.program_code"></program-selectbox>
						</b-form-group>
					</b-col>

                  <!-- REGISTRATION TYPE -->
                            <b-col sm="6" md="3">
                    <b-form-group :label="$t('registration_type')">
                      <parameter-selectbox v-model="datatable.queryParams.filter.registration_type"
                                           code="registration_types"></parameter-selectbox>
                    </b-form-group>
                            </b-col>

                    <!-- STUDENT STATUS -->
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('student_status')">
                            <parameter-selectbox code="student_statuses"
                                                 v-model="datatable.queryParams.filter.student_status"></parameter-selectbox>
                        </b-form-group>
                    </b-col>

                  <!-- SLOT STATUS -->
                  <b-col sm="6" md="3">
                    <b-form-group :label="$t('slot_status')">
                      <status-selectbox v-model="datatable.queryParams.filter.slot_status"></status-selectbox>
                    </b-form-group>
                  </b-col>
				</b-row>
			</datatable-filter>
			<div class="mb-3 d-flex gap-2 ">
				<b-button
					size="sm"
					variant="primary"
					class="mr-2"
					:disabled="!selectedRows || selectedRows.length === 0"
					@click="updateFormShow"
				>
					{{ $t('update_selected_slots') }}
				</b-button>

				<b-button
					size="sm"
					variant="danger"
					:disabled="!selectedRows || selectedRows.length === 0"
					@click="deleteSelectedSlots"
				>
					{{ $t('delete_selected_slots') }}
				</b-button>
			</div>
			<datatable ref="myDatatable"
					:isLoading.sync="datatable.isLoading"
					:columns="datatable.columns"
					:rows="datatable.rows"
					:total="datatable.total"
					:queryParams="datatable.queryParams"
					@on-page-change="onPageChange"
					@on-sort-change="onSortChange"
					@on-per-page-change="onPerPageChange"
					v-show="datatable.showTable"
					:selectOptions="true"
					@on-selected-rows-change="getSelectedRows">
					<div slot="selected-row-actions"></div>
			</datatable>
			<CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('new') }}
				</template>
				<template v-slot:CommonModalContent>
					<create-form @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'" />
				</template>
			</CommonModal>
			<CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ changeText($t('edit')) }}
				</template>
				<template v-slot:CommonModalContent>
					<update-form :formId="formId" :selectedIds="selectedRows" @updateFormSuccess="updateFormSuccess" v-if="formProcess == 'update'" />
				</template>
			</CommonModal>
		</app-layout>
	</div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";

// Pages
import CreateForm from "./CreateForm";
import UpdateForm from "./UpdateForm";

// Services
import StudentSlotBulkService from "@/services/StudentSlotBulkService";

// Others
import { ValidationProvider, ValidationObserver } from "vee-validate"
import qs from 'qs'

export default {
	components: {
		AppLayout,
		Header,
		HeaderMobile,

		DatatableFilter,
		Datatable,
		CommonModal,
		FacultySelectbox,
		DepartmentSelectbox,
		ParameterSelectbox,
		ProgramSelectbox,
		StatusSelectbox,

		CreateForm,
		UpdateForm,

		ValidationProvider,
		ValidationObserver
	},
	metaInfo() {
		return {
			title: this.$t('student_slots_bulk_search')
		}
	},
	data() {
		return {
			datatable: {
				isLoading: false,
				columns: [
					{
						label: this.toUpperCase('slot_id'),
						field: 'slot_id',
						hidden: false,
					},
                    {
                        label: this.toUpperCase('student_slot_id'),
                        field: 'id',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('student_number'),
                        field: 'student_number',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('faculty'),
                        field: 'faculty_name',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('program'),
                        field: 'program_name',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('semester_count'),
                        field: 'semester_count',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('registration_semester'),
                        field: ('registration_semester'),
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('registration_type'),
                        field: 'registration_type',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('course_code'),
                        field: 'course_code',
                        hidden: false,
                        sortable: true
                    },
                    {
                        label: this.toUpperCase('course_name'),
                        field: 'course_name',
                        hidden: false,
                        sortable: true
                    },
                    {
                        label: this.toUpperCase('slot_type'),
                        field: 'slot_type',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('letter_grade'),
                        field: 'student_courses',
                        hidden: false,
                        sortable: false,
                        formatFn: (value, row) => {
                            if (row.student_courses && row.student_courses.length > 0) {
                                return row.student_courses[0].letter_grade
                            }
                        }
                    },
                    {
                        label: this.toUpperCase('elective_pool'),
                        field: 'pool',
                        hidden: false,
                        sortable: false,
                        formatFn: (value, row) => {
                          if(value) {
                            return value.name;
                          }
                          return '';
                        }
                    },
                    {
                        label: this.toUpperCase('elective_pool_id'),
                        field: 'pool_id',
                        hidden: false,
                        sortable: false
                    },
				],
				rows: [],
				total: 0,
				filterStatus: true,
				showTable: false,
				queryParams: {
					filter: {},
					sort: 'id',
					page: 1,
					limit: 20
				}
			},
			formProcess: null,
			formId: null,
			form: {},
            selectedRows: null,
		}
	},
	created() {
		this.filterSet();
		this.formClear();
	},
	methods: {
		filterSet() {
			this.datatable.queryParams.filter = {
				slot_id: null,
				course_code: null,
				faculty_code: null,
				department_code: null,
				program_code: null,
				registration_type: null,
				registration_type: null,
			}
		},
		filterClear() {
			this.filterSet()
			this.getRows();
		},
		filter() {
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		onPageChange(params) {
			this.datatable.queryParams.page = params.currentPage;
			this.getRows();
		},
		onPerPageChange(params) {
			this.datatable.queryParams.limit = params.currentPerPage;
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		changeColumn(key) {
			this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
		},
		onSortChange(params) {
			const sortType = params[0].type == 'desc' ? '-' : '';
			this.datatable.queryParams.sort = sortType + params[0].field
			this.getRows();
		},
		getRows() {
			this.datatable.showTable = true;
			this.datatable.isLoading = true;

			const config = {
				params: {
					...this.datatable.queryParams
				},
				paramsSerializer: (params) => qs.stringify(params, { encode: false })
			};

			return StudentSlotBulkService.getAll(config)
				.then((response) => {
					this.datatable.rows = response.data.data
					this.datatable.total = response.data.pagination.total

					this.datatable.rows.forEach((c) => c.status = c.status == 'a' ? this.$t('active') : this.$t('passive'))
				})
				.finally(() => {
					this.datatable.isLoading = false;
				});
		},

		// Clear
		formClear() {
			this.formId = null
			this.formProcess = null
		},

		// Create
		createFormShow() {
			this.formId = null
			this.formProcess = 'create'
			this.$refs.createFormModal.$refs.commonModal.show()
		},
		createFormSuccess() {
			this.$refs.createFormModal.$refs.commonModal.hide()
			this.getRows()
			this.formClear()
		},

		// Update
		updateFormShow() {
			this.formProcess = 'update'
			this.$refs.updateFormModal.$refs.commonModal.show()
		},
		updateFormSuccess() {
			this.$refs.updateFormModal.$refs.commonModal.hide()
			this.getRows()
			this.formClear()
		},
        formDelete(id) {
          this.$swal
              .fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
              })
              .then((result) => {
                if (result.isConfirmed) {
                  StudentSlotBulkService.del(id)
                      .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.getRows()
                        this.formClear()
                      })
                      .catch(error => {
                        this.$toast.error(this.$t('api.' + error.data.message))
                      })
                }
              })
        },
        getSelectedRows(rows) {
            this.selectedRows = rows.selectedRows.map(row => row.id)
        },
		deleteSelectedSlots() {
			if (!this.selectedRows || this.selectedRows.length === 0) return;
				this.$swal.fire({
				text: this.$t('are_you_sure_to_delete'),
				showCancelButton: true,
				confirmButtonText: this.$t('yes'),
				cancelButtonText: this.$t('no')
			}).then(result => {
				if (result.isConfirmed) {
					const payload = {
						student_slot_id: this.selectedRows,
						operation_type: 'delete'
					};
					StudentSlotBulkService.update(payload)
					.then(response => {
						this.$toast.success(this.$t('api.' + response.data.message));
						this.getRows();
						this.formClear();
					})
					.catch(error => {
						this.$toast.error(this.$t('api.' + error.data.message));
					});
				}
			});
		}

    }
}
</script>
<style>
.vgt-selection-info-row.clearfix {
  display: none !important;
}
</style>
